import React from 'react';

class ListItemThongKeTiepCongDan extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  render() {
    let Item = this.props.item || {};
    return (
      <tr className={this.props.sum ? 'txt-bold' : ''}>
        <td className='column-stt-fixed'>{this.props.count}</td>
        <td className='column-name-fixed'>{Item.donVi ? Item.donVi.ten : (Item.capDonVi ? Item.capDonVi.ten : '')}</td>

        <td className='txt-center'>{Item.tiepCongDanThuongXuyenLuot ? Item.tiepCongDanThuongXuyenLuot : 0}</td>
        <td className='txt-center'>{Item.tiepCongDanThuongXuyenNguoi ? Item.tiepCongDanThuongXuyenNguoi : 0}</td>
        <td className='txt-center'>{Item.tiepCongDanThuongXuyenVuViecCu ? Item.tiepCongDanThuongXuyenVuViecCu : 0}</td>
        <td className='txt-center'>{Item.tiepCongDanThuongXuyenVuViecMoiPhatSinh ? Item.tiepCongDanThuongXuyenVuViecMoiPhatSinh : 0}</td>

        <td className='txt-center'>{Item.tiepCongDanThuongXuyenDoanDongNguoiSoDoan ? Item.tiepCongDanThuongXuyenDoanDongNguoiSoDoan : 0}</td>
        <td className='txt-center'>{Item.tiepCongDanThuongXuyenDoanDongNguoiSoNguoi ? Item.tiepCongDanThuongXuyenDoanDongNguoiSoNguoi : 0}</td>
        <td className='txt-center'>{Item.tiepCongDanThuongXuyenDoanDongNguoiVuViecCu ? Item.tiepCongDanThuongXuyenDoanDongNguoiVuViecCu : 0}</td>
        <td className='txt-center'>{Item.tiepCongDanThuongXuyenDoanDongNguoiVuViecMoiPhatSinh ? Item.tiepCongDanThuongXuyenDoanDongNguoiVuViecMoiPhatSinh : 0}</td>

        <td className='txt-center'>{Item.tiepCongDanDinhKyDotXuatCuaLanhDaoLuot ? Item.tiepCongDanDinhKyDotXuatCuaLanhDaoLuot : 0}</td>
        <td className='txt-center'>{Item.tiepCongDanDinhKyDotXuatCuaLanhDaoNguoi ? Item.tiepCongDanDinhKyDotXuatCuaLanhDaoNguoi : 0}</td>
        <td className='txt-center'>{Item.tiepCongDanDinhKyDotXuatCuaLanhDaoVuViecCu ? Item.tiepCongDanDinhKyDotXuatCuaLanhDaoVuViecCu : 0}</td>
        <td className='txt-center'>{Item.tiepCongDanDinhKyDotXuatCuaLanhDaoVuViecMoiPhatSinh ? Item.tiepCongDanDinhKyDotXuatCuaLanhDaoVuViecMoiPhatSinh : 0}</td>

        <td className='txt-center'>{Item.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiSoDoan ? Item.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiSoDoan : 0}</td>
        <td className='txt-center'>{Item.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiSoNguoi ? Item.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiSoNguoi : 0}</td>
        <td className='txt-center'>{Item.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiVuViecCu ? Item.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiVuViecCu : 0}</td>
        <td className='txt-center'>{Item.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiVuViecMoiPhatSinh ? Item.tiepCongDanDinhKyDotXuatCuaLanhDaoDoanDongNguoiVuViecMoiPhatSinh : 0}</td>

        <td className='txt-center'>{Item.tongVuViecDonKhieuNaiLinhVucHanhChinh ? Item.tongVuViecDonKhieuNaiLinhVucHanhChinh : 0}</td>
        <td className='txt-center'>{Item.donKhieuNaiLinhVucHanhChinhLienQuanDenDatDai ? Item.donKhieuNaiLinhVucHanhChinhLienQuanDenDatDai : 0}</td>
        <td className='txt-center'>{Item.donKhieuNaiLinhVucHanhChinhVeNhaTaiSan ? Item.donKhieuNaiLinhVucHanhChinhVeNhaTaiSan : 0}</td>
        <td className='txt-center'>{Item.donKhieuNaiLinhVucHanhChinhVeChinhSachCCVC ? Item.donKhieuNaiLinhVucHanhChinhVeChinhSachCCVC : 0}</td>
        <td className='txt-center'>{Item.donKhieuNaiLinhVucHanhChinhVeChinhCTVHXHKKhac ? Item.donKhieuNaiLinhVucHanhChinhVeChinhCTVHXHKKhac : 0}</td>

        <td className='txt-center'>{Item.donKhieuNaiLinhVucTuPhap ? Item.donKhieuNaiLinhVucTuPhap : 0}</td>
        <td className='txt-center'>{Item.donKhieuNaiLinhVucVeDang ? Item.donKhieuNaiLinhVucVeDang : 0}</td>

        <td className='txt-center'>{Item.tongVuViecDonToCao ? Item.tongVuViecDonToCao : 0}</td>
        <td className='txt-center'>{Item.donToCaoLinhVucHanhChinh ? Item.donToCaoLinhVucHanhChinh : 0}</td>
        <td className='txt-center'>{Item.donToCaoLinhVucTuPhap ? Item.donToCaoLinhVucTuPhap : 0}</td>
        <td className='txt-center'>{Item.donToCaoLinhVucThamNhung ? Item.donToCaoLinhVucThamNhung : 0}</td>
        <td className='txt-center'>{Item.donToCaoLinhVucVeDang ? Item.donToCaoLinhVucVeDang : 0}</td>
        <td className='txt-center'>{Item.donToCaoLinhVucKhac ? Item.donToCaoLinhVucKhac : 0}</td>

        <td className='txt-center'>{Item.phanAnhKienNghiKhac ? Item.phanAnhKienNghiKhac : 0}</td>

        <td className='txt-center'>{Item.chuaDuocGiaiQuyet ? Item.chuaDuocGiaiQuyet : 0}</td>
        <td className='txt-center'>{Item.chuaCoQuyetDinhGiaiQuyet ? Item.chuaCoQuyetDinhGiaiQuyet : 0}</td>
        <td className='txt-center'>{Item.daCoQuyetDinhGiaiQuyet ? Item.daCoQuyetDinhGiaiQuyet : 0}</td>
        <td className='txt-center'>{Item.daCoBanAnCuaToa ? Item.daCoBanAnCuaToa : 0}</td>

        <td className='ghi-chu'>{Item.ghiChu ? Item.ghiChu : ''}</td>
      </tr>
    );
  }
}

export default ListItemThongKeTiepCongDan;


// WEBPACK FOOTER //
// ./src/components/modules/thong-ke-bao-cao/datatable/ListItemThongKeTiepCongDan.jsx